module.exports = __webpack_public_path__ + "img/AddressInfo.8c7a0f07.svg";